import { ReactNode } from 'react';
import { IconName } from '@optimus-web/icons';
import { Grid } from '../Grid';
import { GridProps } from '../Grid/types';
import { SelectOption } from '../SelectOption/SelectOption';

interface Option {
    label: ReactNode;
    value: string;
    name: string;
    description?: ReactNode;
    icon?: IconName;
    checked?: boolean;
}

interface SelectOptionGroupCommonProps extends GridProps {
    options: Array<Option>;
    direction: 'vertical' | 'horizontal';
    disabled?: boolean;
}
interface RadioSelectOptionGroupProps extends SelectOptionGroupCommonProps {
    type: 'radio';
    onChange: (e: React.ChangeEvent<HTMLInputElement>, value: string) => void;
    inputValue: string;
}
interface CheckboxSelectOptionGroupProps extends SelectOptionGroupCommonProps {
    type: 'checkbox';
    onChange: (e: React.SyntheticEvent<HTMLElement>, value: string[]) => void;
    inputValue: string[];
}

export type SelectOptionGroupProps = CheckboxSelectOptionGroupProps | RadioSelectOptionGroupProps;

export const SelectOptionGroup = ({
    options,
    direction,
    disabled = false,
    type,
    onChange,
    inputValue,
    ...other
}: SelectOptionGroupProps) => {
    const handleChange =
        (handledValue: string) =>
        (event: React.ChangeEvent<HTMLInputElement> | React.SyntheticEvent<HTMLElement>, checked: boolean) => {
            if (onChange) {
                if (type === 'checkbox') {
                    const newValue = checked
                        ? [...inputValue, handledValue]
                        : inputValue.filter((item) => handledValue !== item);
                    onChange(event, newValue);
                } else {
                    onChange(event as React.ChangeEvent<HTMLInputElement>, handledValue);
                }
            }
        };
    const result = options.map(({ label, value, description, icon, name }) => (
        <SelectOption
            label={label}
            value={value}
            name={name}
            description={description}
            icon={icon}
            direction={direction}
            disabled={disabled}
            type={type}
            checked={type === 'radio' ? inputValue === value : inputValue.includes(value)}
            key={value}
            onChange={handleChange(value)}
        />
    ));
    return (
        <Grid
            {...other}
            autoRows={direction === 'horizontal' ? '1fr' : 'auto'}
            templateRows={direction === 'horizontal' ? 'none' : 'auto'}
        >
            {result}
        </Grid>
    );
};
